import { buildTx, getQuote } from "@7kprotocol/sdk-ts";
export class SevenKGateway {
    constructor() { }
    async getQuote(tokenIn, tokenOut, amountIn, excludedPools) {
        const quoteResponse = await getQuote({
            tokenIn,
            tokenOut,
            amountIn,
            excludedPools,
        });
        return quoteResponse;
    }
    async getTransactionBlock(tx, address, quoteResponse, slippage, coinIn) {
        const { coinOut } = await buildTx({
            quoteResponse,
            accountAddress: address,
            slippage,
            commission: {
                partner: address, // Use the user's address as partner
                commissionBps: 0, // 0 basis points = no commission
            },
            extendTx: {
                tx,
                coinIn,
            },
        });
        return coinOut;
    }
}
//# sourceMappingURL=7k.js.map